<template>
  <div class="home-container">
    <div v-if="isMobile">
      <!-- 统一AppNav风格的移动端header -->
      <el-header class="mobile-header-appnav">
        <span class="nav-title">4KHD 网盘资源管理系统</span>
        <el-button class="menu-btn" icon="el-icon-menu" circle plain type="primary" @click="showMobileMenu = true"></el-button>
      </el-header>
      <!-- 移动端顶部固定搜索栏 -->
      <div class="mobile-search-bar-fixed">
        <div class="mobile-search-bar-opt">
          <el-popover
            placement="bottom-start"
            width="240"
            trigger="click"
            v-model="showPanSelect"
            popper-class="mobile-pan-popover"
            @after-leave="applyPanSelect"
          >
            <div class="mobile-pan-popover-content">
              <el-checkbox-group v-model="tempPan" class="mobile-pan-checkbox-group">
                <el-checkbox label="baidu">百度</el-checkbox>
                <el-checkbox label="aliyun">阿里云</el-checkbox>
                <el-checkbox label="quark">夸克</el-checkbox>
                <el-checkbox label="uc">UC</el-checkbox>
                <el-checkbox label="tianyiyun">天翼</el-checkbox>
                <el-checkbox label="115">115</el-checkbox>
                <el-checkbox label="123">123</el-checkbox>
                <el-checkbox label="pikpak">PikPak</el-checkbox>
                <el-checkbox label="xunlei">迅雷</el-checkbox>
                <el-checkbox label="magnet">磁力</el-checkbox>
                <el-checkbox label="ed2k">电驴</el-checkbox>
              </el-checkbox-group>
              <el-button type="primary" size="small" @click="confirmPanSelect" class="mobile-pan-confirm-btn">确定</el-button>
            </div>
            <template #reference>
              <el-button
                class="mobile-pan-btn"
                icon="el-icon-menu"
                circle
              ></el-button>
            </template>
          </el-popover>
          <el-input
            v-model="searchForm.q"
            placeholder="输入标题关键词"
            class="mobile-search-input"
            @keyup.enter.native="onSearch"
            clearable
          />
          <el-button
            type="primary"
            class="mobile-search-btn-opt"
            @click="onSearch"
            :loading="loading"
            icon="el-icon-search"
            circle
          ></el-button>
        </div>
      </div>
      <!-- 移动端卡片列表，独立滚动区+无限滚动 -->
      <div class="mobile-card-list-scrollable" ref="mobileScroll" @scroll="handleMobileScroll" v-if="results.length || searched">
        <div v-for="item in results" :key="item.id || item.url" class="mobile-card">
          <div class="mobile-card-title">{{ item.title }}</div>
          <div class="mobile-card-link">
            <el-link :href="item.url" target="_blank" type="primary" @click.native.prevent="copyUrl(item.url)">{{ item.url }}</el-link>
            <el-button type="text" size="mini" @click="copyUrl(item.url)">复制</el-button>
            <el-button type="text" size="mini" @click="copyResource(item)">一键复制链接标题</el-button>
          </div>
          <div class="mobile-card-row">
            <span class="tag-label" :class="getPanTagClass(item.is_type)">{{ getPanTypeText(item.is_type) }}</span>
            <span class="mobile-card-date">{{ item.msg_date }}</span>
          </div>
        </div>
        <div v-if="loading" class="no-data-tip">加载中...</div>
        <div v-if="noMore && results.length" class="no-data-tip">没有更多了</div>
        <div v-if="!results.length && searched && !loading" class="no-data-tip">暂无数据，请尝试其他关键词或筛选条件。</div>
      </div>
      <!-- 移动端空状态 -->
      <div class="mobile-empty-state" v-if="!results.length && !searched">
        <div class="mobile-empty-content">
          <i class="el-icon-search" style="font-size: 48px; color: #c0c4cc; margin-bottom: 16px;"></i>
          <p style="color: #909399; font-size: 16px;">请输入关键词开始搜索</p>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- PC端原有搜索栏 -->
      <div class="page-header">
        <h1 class="page-title">4KHD 网盘资源搜索</h1>
      </div>
      <el-card class="search-card tech-card">
        <el-form :inline="true" :model="searchForm" @submit.native.prevent="onSearch" class="tech-form" :label-position="'right'">
          <el-form-item label="关键词">
            <el-input v-model="searchForm.q" placeholder="请输入关键词" style="width: 220px" class="tech-input" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="网盘类型">
            <el-select v-model="searchForm.pan" multiple placeholder="全部" clearable style="width: 140px" class="tech-select">
              <el-option label="全部" value="" />
              <el-option label="百度" value="baidu" />
              <el-option label="阿里云" value="aliyun" />
              <el-option label="夸克" value="quark" />
              <el-option label="UC" value="uc" />
              <el-option label="天翼" value="tianyiyun" />
              <el-option label="115" value="115" />
              <el-option label="123" value="123" />
              <el-option label="Pikpak" value="pikpak" />
              <el-option label="迅雷" value="xunlei" />
              <el-option label="Magnet" value="magnet" />
              <el-option label="ed2k" value="ed2k" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch" :loading="loading" class="tech-btn">搜索</el-button>
            <el-button
              v-if="!isMobile"
              type="info"
              :disabled="multipleSelection.length === 0"
              @click="copyMultipleResources"
              style="margin-left: 8px; vertical-align: middle;"
            >批量复制标题链接</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="result-card tech-card" v-if="results.length || searched">
        <el-table v-if="!isMobile" :data="results" border stripe style="width: 100%" v-loading="loading" class="tech-table" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" />
          <el-table-column prop="title" label="标题" min-width="180">
            <template slot-scope="scope">
              <span class="copyable" @click="copyUrl(scope.row.url)">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="网盘链接" min-width="280">
            <template slot-scope="scope">
              <el-link :href="scope.row.url" target="_blank" type="primary" @click.native.prevent="copyUrl(scope.row.url)">{{ scope.row.url }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="is_type" label="类型" width="100">
            <template slot-scope="scope">
              <span :class="['tag-label', getPanTagClass(scope.row.is_type)]">
                {{ getPanTypeText(scope.row.is_type) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="msg_date" label="更新时间" width="160" />
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button size="mini" @click="copyResource(scope.row)">一键复制链接标题</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- PC端分页 -->
        <el-pagination
          v-if="!isMobile && total > searchForm.pageSize"
          style="margin: 16px 0 0 0; text-align: right;"
          background
          layout="prev, pager, next, jumper"
          :total="total"
          :current-page="searchForm.page"
          :page-size="searchForm.pageSize"
          @current-change="onPageChange"
        />
        <!-- 移动端卡片列表保持原样 -->
      </el-card>
    </div>
    
    <!-- 移动端抽屉菜单 -->
    <el-drawer
      title="菜单"
      :visible.sync="showMobileMenu"
      direction="ltr"
      size="70%"
      :with-header="false"
      custom-class="mobile-drawer"
    >
      <el-menu
        :default-active="$route.path.replace(/^\//, '') || '/'"
        class="mobile-drawer-menu"
        @select="handleMenuSelect"
      >
        <el-menu-item index="">
          <i class="el-icon-search"></i>
          <span slot="title">资源搜索</span>
        </el-menu-item>
        <el-menu-item index="manageApiKey">
          <i class="el-icon-key"></i>
          <span slot="title">API Key管理</span>
        </el-menu-item>
        <el-menu-item index="userInfo">
          <i class="el-icon-user"></i>
          <span slot="title">会员信息</span>
        </el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="cardManage">
          <i class="el-icon-tickets"></i>
          <span slot="title">卡密管理</span>
        </el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="userManage">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="adminApiKeyManage">
          <i class="el-icon-key"></i>
          <span slot="title">API Key管理（全局）</span>
        </el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="adminApiLogManage">
          <i class="el-icon-document"></i>
          <span slot="title">API日志管理</span>
        </el-menu-item>
      </el-menu>
      <div style="margin: 16px; text-align: center;">
        <el-button type="text" @click="goUserInfo">会员信息</el-button>
        <el-button type="text" @click="logout">退出登录</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      searchForm: {
        q: '',
        pan: [],
        page: 1,
        pageSize: 20
      },
      results: [],
      total: 0,
      loading: false,
      searched: false,
      isMobile: false,
      multipleSelection: [], // PC端表格多选
      showPanSelect: false, // 控制移动端网盘多选弹窗
      tempPan: [], // 移动端弹窗临时选择
      noMore: false, // 无限滚动加载完毕标志
      showMobileMenu: false, // 控制移动端抽屉菜单
      user: {}, // 当前用户信息
    }
  },
  created() {
    // 页面加载时检测apiKey，无则跳转
    const apiKey = localStorage.getItem('api_key');
    if (!apiKey) {
      this.$message.warning('请先生成API Key');
      this.$router.replace('/manageApiKey');
    }
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.fetchUser();
    this.onSearch(); // 页面加载时自动请求最新资源
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    async fetchUser() {
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: 'Bearer ' + token } : {};
        const res = await this.$axios.get('/user/info', { headers });
        if (res && res.code === 200) {
          this.user = res.data || {};
        }
      } catch {}
    },
    async onSearch(resetPage = true) {
      const apiKey = localStorage.getItem('api_key');
      if (!apiKey) {
        this.$message.warning('请先生成API Key');
        this.$router.replace('/manageApiKey');
        return;
      }
      this.loading = true;
      this.searched = true;
      this.noMore = false;
      if (resetPage) this.searchForm.page = 1;
      // H5端搜索后滚动到卡片区顶部
      if (this.isMobile && this.$refs.mobileScroll) {
        this.$nextTick(() => {
          this.$refs.mobileScroll.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
      try {
        const params = {
          q: this.searchForm.q,
          pan: Array.isArray(this.searchForm.pan) ? this.searchForm.pan.filter(Boolean).join(',') : this.searchForm.pan,
          page: this.searchForm.page,
          pageSize: this.searchForm.pageSize,
          api_key: apiKey
        };
        const res = await this.$axios.get('/search', { params });
        if (res && res.code === 200) {
          this.results = res.data;
          this.total = res.total || 0;
        } else {
          this.results = [];
          this.total = 0;
          this.$message.error(res.message || '搜索失败');
        }
      } catch (e) {
        this.results = [];
        this.total = 0;
        this.$message.error(e.response?.data?.message || '网络错误');
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.searchForm.page = page;
      this.onSearch(false); // 不重置page
      // PC端分页切换后滚动到顶部
      if (!this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    copyUrl(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('已复制到剪贴板');
        });
      } else {
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制到剪贴板');
      }
    },
    // 新增：一键复制链接标题方法
    copyResource(row) {
      // 网盘类型映射
      const typeMap = {
        'baidu': '百度',
        'aliyun': '阿里云',
        'quark': '夸克',
        'tianyiyun': '天翼',
        'uc': 'UC',
        'yidong': '移动',
        '115': '115',
        'pikpak': 'PikPak',
        'xunlei': '迅雷',
        '123': '123',
        'magnet': '磁力',
        'ed2k': '电驴'
      };
      const emoji = '🔥';
      const title = row.title || '';
      // 兼容 is_type 可能为中文
      let type = row.is_type;
      if (typeMap[type]) {
        type = typeMap[type];
      } else if (typeof type === 'string' && type.endsWith('网盘')) {
        type = type.replace('网盘', '');
      }
      const link = row.url || '';
      const text = `${emoji}${title}\n${type}: ${link}`;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制链接标题到剪贴板');
        });
      } else {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制链接标题到剪贴板');
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    copyMultipleResources() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择要复制的资源');
        return;
      }
      const typeMap = {
        'baidu': '百度',
        'aliyun': '阿里云',
        'quark': '夸克',
        'tianyiyun': '天翼',
        'uc': 'UC',
        'yidong': '移动',
        '115': '115',
        'pikpak': 'PikPak',
        'xunlei': '迅雷',
        '123': '123',
        'magnet': '磁力',
        'ed2k': '电驴'
      };
      const emoji = '🔥';
      const text = this.multipleSelection.map(item => {
        let type = item.is_type;
        if (typeMap[type]) {
          type = typeMap[type];
        } else if (typeof type === 'string' && type.endsWith('网盘')) {
          type = type.replace('网盘', '');
        }
        return `${emoji}${item.title}\n${type}: ${item.url}`;
      }).join('\n\n');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制所有选中资源标题到剪贴板');
        });
      } else {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制所有选中资源标题到剪贴板');
      }
    },
    getPanTypeText(type) {
      const panTypes = {
        'baidu': '百度网盘',
        'aliyun': '阿里云盘',
        'quark': '夸克网盘',
        'tianyiyun': '天翼云盘',
        'uc': 'UC网盘',
        'yidong': '移动云盘',
        '115': '115网盘',
        'pikpak': 'PikPak',
        'xunlei': '迅雷网盘',
        '123': '123网盘',
        'magnet': '磁力链接',
        'ed2k': '电驴链接'
      };
      return panTypes[type] || type;
    },
    getPanTagClass(type) {
      const map = {
        'baidu': 'tag-pan-baidu',
        'aliyun': 'tag-pan-aliyun',
        'quark': 'tag-pan-quark',
        'tianyiyun': 'tag-pan-other',
        'uc': 'tag-pan-other',
        'yidong': 'tag-pan-other',
        '115': 'tag-pan-115',
        'pikpak': 'tag-pan-other',
        'xunlei': 'tag-pan-other',
        '123': 'tag-pan-123',
        'magnet': 'tag-pan-other',
        'ed2k': 'tag-pan-other'
      };
      return map[type] || 'tag-pan-other';
    },
    openPanSelect() {
      this.tempPan = [...this.searchForm.pan];
      this.showPanSelect = true;
    },
    confirmPanSelect() {
      this.searchForm.pan = [...this.tempPan];
      this.showPanSelect = false;
    },
    applyPanSelect() {
      // 弹窗关闭时自动应用选择
      this.searchForm.pan = [...this.tempPan];
    },
    async loadMoreMobile() {
      if (this.loading || this.noMore) return;
      this.loading = true;
      try {
        const apiKey = localStorage.getItem('api_key');
        if (!apiKey) {
          this.$message.warning('请先生成API Key');
          this.$router.replace('/manageApiKey');
          return;
        }
        const params = {
          q: this.searchForm.q,
          pan: Array.isArray(this.searchForm.pan) ? this.searchForm.pan.filter(Boolean).join(',') : this.searchForm.pan,
          page: this.searchForm.page + 1,
          pageSize: this.searchForm.pageSize,
          api_key: apiKey
        };
        const res = await this.$axios.get('/search', { params });
        if (res && res.code === 200 && res.data.length) {
          this.results = this.results.concat(res.data);
          this.searchForm.page += 1;
          if (res.data.length < this.searchForm.pageSize) this.noMore = true;
        } else {
          this.noMore = true;
        }
      } catch (e) {
        this.noMore = true;
      } finally {
        this.loading = false;
      }
    },
    handleMobileScroll() {
      const el = this.$refs.mobileScroll;
      if (!el) return;
      const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (scrollBottom < 80 && !this.loading && !this.noMore) {
        this.loadMoreMobile();
      }
    },
    handleMenuSelect(index) {
      this.showMobileMenu = false;
      this.$router.push('/' + index);
    },
    goUserInfo() {
      this.showMobileMenu = false;
      this.$router.push('/userInfo');
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/login');
    }
  }
}
</script>

<style scoped>
.home-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
  height: 100%;
  overflow: hidden; /* 防止外层滚动 */
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.search-card {
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.search-card:hover {
  transform: translateY(-2px);
}

.result-card {
  margin-top: 8px;
  transition: all 0.3s ease;
}

.result-card:hover {
  transform: translateY(-2px);
}

.no-data-tip {
  text-align: center;
  color: #666;
  margin: 24px 0 8px 0;
  font-size: 15px;
  font-weight: 500;
}

.copyable {
  cursor: pointer;
  color: #409eff;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.copyable:hover {
  color: #66b1ff;
}

.tech-form .el-form-item__label {
  color: #333;
  font-weight: 500;
}

.tech-form .el-input__inner {
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #333;
}

.tech-form .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.tech-form .el-select .el-input__inner {
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .home-container {
    max-width: 100%;
    padding: 0 16px;
  }
}

@media (min-width: 768px) {
  .home-container {
    margin: 32px auto;
    padding: 0 24px;
    height: auto;
    overflow: visible;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 0 4px;
  }
  .page-title {
    font-size: 1.2rem;
  }
  .search-card .el-form {
    flex-direction: column !important;
    align-items: stretch !important;
    display: flex !important;
  }
  .search-card .el-form-item {
    margin-bottom: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .search-card .el-input,
  .search-card .el-select,
  .search-card .el-button {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }
  .result-card {
    padding: 4px;
  }
  .tech-table {
    overflow-x: auto;
    display: block;
    width: 100%;
  }
  .tech-table .el-table__body-wrapper {
    overflow-x: auto !important;
  }
  .el-table {
    min-width: 600px;
  }
}

/* 动画效果 */
.el-button {
  transition: all 0.3s ease;
}

.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 0 12px 0;
}
.mobile-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 14px 12px 10px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mobile-card-title {
  font-weight: 600;
  font-size: 15px;
  color: #333;
  margin-bottom: 2px;
  word-break: break-all;
}
.mobile-card-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  word-break: break-all;
}
.mobile-card-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}
.mobile-card-date {
  color: #888;
  font-size: 12px;
}
@media (min-width: 768px) {
  .mobile-card-list { display: none; }
}
@media (max-width: 767px) {
  .tech-table { display: none !important; }
}
.mobile-search-bar-opt {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 8px 10px;
  margin: 12px 8px 8px 8px;
  gap: 8px;
}
.mobile-pan-btn,
.mobile-search-btn-opt {
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  font-size: 20px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  background: #f5f7fa;
  color: #409EFF;
  box-shadow: none;
}
.mobile-search-btn-opt {
  background: linear-gradient(90deg, #409EFF 60%, #66b1ff 100%);
  color: #fff;
  border: none;
}
.mobile-search-input {
  flex: 1;
  border-radius: 10px;
  font-size: 16px;
  height: 40px;
  margin: 0 4px;
  display: flex;
  align-items: center;
}
.mobile-pan-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 15px;
}
.mobile-pan-popover {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(64,158,255,0.10);
  padding: 12px 10px 10px 10px;
}
.mobile-pan-popover-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.mobile-pan-checkbox-group .el-checkbox {
  margin-bottom: 8px;
  font-size: 17px;
  --el-checkbox-size: 22px;
}
.mobile-pan-confirm-btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 12px;
  font-size: 16px;
}
.mobile-pagination-bar {
  display: flex;
  justify-content: center;
  margin: 18px 0 8px 0;
}
.mobile-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 120;
  background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
  color: #fff;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px; /* 与AppNav一致 */
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.nav-title {
  font-weight: 900;
  font-family: 'Orbitron', 'Roboto', 'Arial', sans-serif;
  font-size: 1.5rem;
  letter-spacing: 2px;
  color: #fff;
  flex: 1;
  text-align: left;
}
.menu-btn {
  display: inline-block !important;
  color: #fff;
  background: #409EFF;
  border: none;
  box-shadow: none;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  font-size: 22px;
  padding: 0;
  align-items: center;
  justify-content: center;
  margin: 0;
}
.mobile-search-bar-fixed {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.mobile-card-list-scrollable {
  position: fixed;
  top: 116px; /* header(60) + search(56) */
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 增加iOS滚动惯性 */
  background: #f7f8fa;
  padding: 12px 8px 8px 8px;
}
.mobile-empty-state {
  position: fixed;
  top: 116px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.mobile-empty-content {
  text-align: center;
  padding: 40px 20px;
}
.mobile-drawer-content {
  padding: 20px 0;
}
.mobile-drawer-menu {
  border-right: none;
}
.mobile-drawer-menu .el-menu-item {
  height: 56px;
  line-height: 56px;
  font-size: 16px;
}
.mobile-drawer-menu .el-menu-item i {
  margin-right: 12px;
  font-size: 18px;
}
.mobile-drawer {
  padding-top: 20px;
}
</style> 